import '@splidejs/splide/css';
import "@theme/front/init.scss"

import Nette from "./front/netteForms"
import Typed from "typed.js"
import { SplideShaderCarousel, maskShader } from './front/splide-shader-carousel.esm';
import animateScrollTo from "animated-scroll-to"
Nette.initOnLoad()
window.Nette = Nette

document.addEventListener("DOMContentLoaded", () => {
	const metaViewport = document.querySelector('meta[name="viewport"]');
	metaViewport.setAttribute('content', 'width=device-width, initial-scale=1, user-scalable=no');

	let typed = initTypedText()

	const splide = new SplideShaderCarousel( '.splide', maskShader, {
		autoplay    : false,
		type        : 'fade',
		autoWidth   : false,
		autoHeight  : false,
		rewind      : true,
		continuous  : true,
		arrows      : true,
		pagination  : false,
		lazyLoad    : 'sequential',
		height      : 600,
		breakpoints : {
			991: {
				pagination: true,
				height : 300,
			}
		},
		mask        : window.baseUrl + '/dist/img/cloud01.jpg',
	})

	splide.mount();

	$(".scroll").on("click", function (e) {
		e.preventDefault()
		e.stopPropagation()

		animateScrollTo(document.querySelector($(this).attr("href")), {
			verticalOffset: (window.innerWidth > 991) ? (window.innerWidth > 1366 ? 50 : 120) : 0,
			cancelOnUserAction: false,
			easing: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
			minDuration: 800,
		})
	})

	function initPianoScroll() {
		if (window.scrollY > window.innerHeight) {
			window.removeEventListener('scroll', initPianoScroll)
			initPiano()
		}
	}

	initPianoScroll()
	window.addEventListener('scroll', initPianoScroll)

	if (window.innerWidth > 991) {
		initOwlAnimation()
	}
})

function initOwlAnimation() {
	setTimeout(() => {
		setInterval(() => {
			for (let i = 2; i <= 3; i++) {
				const elementHidden = getRandomElementWithClass('.animate-0' + i, '.hide')

				if (elementHidden !== null) {
					elementHidden.classList.remove('hide')
				}
			}
		}, 500)
	}, 2500)

	setInterval(function () {
		for (let i = 2; i <= 3; i++) {
			const elementShown = getRandomElementWithClass('.animate-0' + i, ':not(.hide)')

			if (elementShown !== null) {
				elementShown.classList.add('hide')
			}
		}
	}, 500)
}

function initTypedText() {
	return new Typed('#typed-text', {
		stringsElement: '#typed-strings',
		typeSpeed: 30,
		backDelay: 2200,
		startDelay: 0,
		fadeOut: true,
		smartBackspace: true,
		loop: true,
		contentType: 'html',
	})
}

function initPiano(){
	let i = 1;
	const cols = document.querySelectorAll('.piano .col');

	cols.forEach(col => {
		const duration = Math.floor(Math.random() * 1000) + 2000;

		const columnElement = col.querySelector('.column');
		if (columnElement) {
			columnElement.style.animationDuration = `${duration}ms`;
		}

		const hoverElement = col.querySelector('.hover');
		if (hoverElement) {
			hoverElement.style.animationDelay = `${-(i * 10)}ms`;
		}

		i++;
	});

	setInterval(function () {
		let i = 0;
		let colInterval = setInterval(function () {
			const column = $('.col-number-' + i)
			column.addClass('hover')

			setTimeout(function () {
				column.removeClass('hover')
			}, 50)

			i++;

			if (i > 100) {
				clearInterval(colInterval)
			}
		}, 50)
	}, window.innerWidth < 991 ? 5_000 : 10_000)
}

function getRandomElementWithClass(parentSelector, childSelector) {
	const parentElement = document.querySelector(parentSelector)

	if (!parentElement) {
		return null
	}

	const childElements = parentElement.querySelectorAll(`${childSelector}`)

	if (childElements.length === 0) {
		return null
	}

	const randomIndex = Math.floor(Math.random() * childElements.length)

	return childElements[randomIndex]
}
